import {
  restaurantsPath,
} from './restaurantRequests';

export const restaurantCategoriesPath = 'categories';
export const getRestaurantCategories = (restaurantId: number) => `${restaurantsPath}/${restaurantId}/${restaurantCategoriesPath}`;
export const getRestaurantCategoryById = (id: number) => `${restaurantsPath}/${restaurantCategoriesPath}/${id}`;
export const createRestaurantCategory = (restaurantId: number) => `${restaurantsPath}/${restaurantId}/${restaurantCategoriesPath}`;
export const updateRestaurantCategory = (id: number) => `${restaurantsPath}/${restaurantCategoriesPath}/${id}`;
export const updateRestaurantCategoryStatus = (id: number) => `${restaurantsPath}/${restaurantCategoriesPath}/${id}/activation`;
